import { render, staticRenderFns } from "./VideoQuestion.vue?vue&type=template&id=4401f142&"
import script from "./VideoQuestion.vue?vue&type=script&lang=js&"
export * from "./VideoQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports